import styled from "styled-components";
import { FaTwitter, FaYoutube, FaLinkedinIn, FaFacebookF, FaInstagram } from "react-icons/fa";
import { Container } from "../../theme/styles";
import logoSrc from "../../assets/images/logo.png"
import medias_url from "../../mocks/social_media";

interface SimpleContainerProps {
  isReverse?: boolean;
  padding? : string;
}

export function Footer() {
  return (
    <Content>
      <ContentTop>
        <Container>
          <FlexContainer>
            <SimpleContainer>
              <LogoUI src={logoSrc} />
            </SimpleContainer>
            <SimpleContainer isReverse={true}>
              <Text>Todo o conteúdo criado por integrantes do ONDA é licenciado sob a licença CC-BY-NC-SA. Os demais conteúdos podem estar disponíveis sob outras licenças, sendo recomendável a sua leitura integral.</Text>
              <SocialList>
                <SocialItem>
                  <LinkUI href={medias_url.facebook} target="_blank">
                    <FaFacebookF size={26} />
                  </LinkUI>
                </SocialItem>
                <SocialItem>
                  <LinkUI href={medias_url.instagram} target="_blank">
                    <FaInstagram size={26} />
                  </LinkUI>
                </SocialItem>
                <SocialItem>
                  <LinkUI href={medias_url.twitter} target="_blank">
                    <FaTwitter size={26} />
                  </LinkUI>
                </SocialItem>
                <SocialItem>
                  <LinkUI href={medias_url.youtube} target="_blank">
                    <FaYoutube size={26} />
                  </LinkUI>
                </SocialItem>
                <SocialItem>
                  <LinkUI href={medias_url.linkedin} target="_blank">
                    <FaLinkedinIn size={26} />
                  </LinkUI>
                </SocialItem>
              </SocialList>
            </SimpleContainer>
            <Spacer />
            <SimpleContainerLast padding={'20px 14px 0'}>
              <TextLink href={medias_url.privatePolice} target="_blank">Política de Privacidade</TextLink>
              <br></br>
              {/* <small> */}
                <TextLast>
                  Contato: {`${medias_url.contactEmail}`}
                </TextLast>
              {/* </small> */}
              <br></br>
              {/* <small> */}
                <TextLast>
                  Rua Evaristo da Veiga 16, Grupo 1407
                </TextLast>
              {/* </small> */}
              <br></br>
              {/* <small> */}
                <TextLast>
                  Centro – Rio de Janeiro/RJ, CEP: 20.031-040
                </TextLast>
              {/* </small> */}
              {/* <br></br>
              <small>CEP: 20.031-040</small> */}
            </SimpleContainerLast>
          </FlexContainer>
        </Container>
      </ContentTop>
    </Content>
  );
}

const Content = styled.footer`
  background-color: ${({ theme }) => theme.colors.black.dark};
`;

const FlexContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  max-width: 1020px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    flex-direction: column;
    // align-items: center;
  }
`;

const ContentTop = styled.div`
  background-color: ${({ theme }) => theme.colors.black.dark};
  padding: 76px 0 12px;
  display: flex;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: 26px 0;
  }
`;

const LogoUI = styled.img`
  width: 172px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    display: none;
  }
`;

const Text = styled.p`
  color: #fff;
  max-width: 500px;
  padding-right: 150px;
  padding-bottom: 20px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: 0;
    text-align: center;
    // font-size: small;
    font-size: small;
    padding-bottom: 20px;

  }
`;

const SocialList = styled.ul`
  display: flex;
  list-style-type: none;
  margin-bottom: 12px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    //display: none;
    margin-bottom: 10px;

  }
`;

const SocialItem = styled.li`
  padding: 4px 6px 0 6px;
  border: 1px solid;
  margin: 0 3px;

`;

const LinkUI = styled.a`
  color: ${({ theme }: any) => theme.colors.gray.light};

  &:hover, &:active {
    opacity: 0.7;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    color: #fff;
  }
`;

const TextLink = styled.a`
  color: ${({ theme }: any) => theme.colors.gray.light};
  border: 1px solid;
  padding: 0 10px;
  text-decoration: none;

  &:hover, &:active {
    opacity: 0.7;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    //display: flex;
  }
`;

const Spacer = styled.hr`
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    display: block;
    width: 100%;
    max-width: 400px;
    height: 2px;
    margin: auto;
    border: none;
    background-color: ${({ theme }) => theme.colors.gray.light};
  }
`;

export const SimpleContainer = styled.div<SimpleContainerProps>`
  color: #fff;
  margin: 0 auto;
  padding: 0 14px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: ${({ padding }) => padding? padding : '0 14px' };

    display: flex;
    flex-direction: ${({ isReverse }) => isReverse? 'column-reverse' : 'column' };
    font-size: medium;
    align-items: center;

  }
`;

export const SimpleContainerLast = styled.div<SimpleContainerProps>`
  color: #fff;
  margin: 0 auto;
  padding: 0 4px;

  @media screen and (min-width: ${({ theme }) => theme.device.screen}) {
    width: 100%;
    max-width: 330px;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: ${({ padding }) => padding? padding : '0 14px' };

    display: flex;
    flex-direction: ${({ isReverse }) => isReverse? 'column-reverse' : 'column' };
    font-size: medium;
    align-items: center;

  }
`;
const TextLast = styled.span`
  color: #fff;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: 0;
    text-align: center;
    // font-size: small;
    font-size: small;

  }
`;